import { Calendar, MapPin, Users, Video } from "lucide-react";
import { MockPhoto } from "@/src/common/components/app-mock/media";
import { EVENT_FORMAT_LABEL, type MockCommunityEvent } from "@/src/common/components/app-mock/mock-community";
import { MOCK_TOKENS, MockButton, MockChip } from "@/src/common/components/app-mock/primitives";

interface EventCardCompactProps {
	event: MockCommunityEvent;
	cover?: boolean;
}

export function EventCardCompact({ event, cover = true }: EventCardCompactProps) {
	const FormatIcon = event.format === "in_person" ? MapPin : Video;
	return (
		<div
			className="mt-2 overflow-hidden rounded-xl border bg-white"
			style={{ borderColor: MOCK_TOKENS.border }}
			data-mock="event-card-compact"
		>
			{cover ? <MockPhoto scene={event.scene} className="h-24 w-full" rounded="rounded-none" /> : null}
			<div className="space-y-1.5 p-3">
				<div className="flex flex-wrap items-center gap-1">
					{event.price === 0 ? (
						<MockChip color="success" size="xs">
							Free
						</MockChip>
					) : (
						<MockChip color="warning" size="xs">
							Paid
						</MockChip>
					)}
					{event.recurrence ? <MockChip size="xs">{event.recurrence}</MockChip> : null}
				</div>
				<p className="line-clamp-2 text-[11px] font-semibold text-neutral-900">{event.title}</p>
				<p className="line-clamp-2 text-[10px] text-neutral-500">{event.description}</p>
				<div className="space-y-0.5 text-[10px] text-neutral-500">
					<p className="flex items-center gap-1">
						<Calendar className="size-3" />
						{event.dateLabel} · {event.time}
					</p>
					<p className="flex items-center gap-1">
						<FormatIcon className="size-3" />
						{EVENT_FORMAT_LABEL[event.format]} · {event.location}
					</p>
					<p className="flex items-center gap-1">
						<Users className="size-3" />
						{event.spots} spots
					</p>
				</div>
				<MockButton variant="secondary" size="xs" fullWidth>
					View Event
				</MockButton>
			</div>
		</div>
	);
}
